import React from 'react';
import { useTranslation } from 'react-i18next';

const Posts = () => {
    const { t } = useTranslation();
    
    return (
        <div className="page-content">
            <h1>{t('nav.posts')}<span className="accent">.</span></h1>
            <p>Posts coming soon...</p>
        </div>
    );
};

export default Posts;

